<template>
  <div>
    <servicos-modal v-if="modalServicos" v-model="modalServicos" @fecharModalServicos="fecharModalServicos"/>
    <v-row class="white ma-0 pa-0 mb-5">
      <v-col cols="12">
        <v-card>
          <v-toolbar dark color="primary" elevation="0">
            <v-toolbar-title class="d-inline-block text-truncate">Odontograma</v-toolbar-title>
            <v-spacer/>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="abrirModalServicos">
                  <v-img src="/images/servico-icone.png" contain height="50" width="50"/>
                </v-btn>
              </template>
              Abrir modal de serviços
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="modoVisualizarQuadrante">
                  <v-icon :color="visualizarQuadrantes ? '#b1de9c' : '#f5f3f4'">border_all</v-icon>
                </v-btn>
              </template>
              {{ visualizarQuadrantes ? 'Desativar visualização de quadrantes' : 'Ativar visualização de quadrantes' }}
            </v-tooltip>
          </v-toolbar>
          <v-container fluid grid-list-xl class="pa-0">
            <v-card-text class="container-um-odontograma">
              <div class="container-lateral-atendimentos">
                <OdontogramaAtendimento @atualizarAtendimentoSelecionado="selecionarAtendimento"
                                        @removerAtendimentoSelecionado="removerAtendimentoSelecionado"
                                        @buscarHistoricoProcedimentos="buscarHistoricoProcedimentos"
                />
              </div>
              <div class="container-odontograma">
                <div v-if="visualizarQuadrantes" class="container-lado-quadrante">
                  <label>Direita</label>
                </div>
                <div>
                  <OdontogramaArcadaSuperior
                      :visualizar-quadrantes="visualizarQuadrantes"
                      :dentes-quadrante1="dentesQuadrante1"
                      :dentes-quadrante2="dentesQuadrante2"
                      @selecionarDenteEvento="selecionarDente"
                  />
                  <OdontogramaArcadaInferior
                      :visualizar-quadrantes="visualizarQuadrantes"
                      :dentes-quadrante3="dentesQuadrante3"
                      :dentes-quadrante4="dentesQuadrante4"
                      @selecionarDenteEvento="selecionarDente"
                  />
                </div>
                <div v-if="visualizarQuadrantes" class="container-lado-quadrante">
                  <label>Esquerda</label>
                </div>
              </div>
              <div class="container-lateral-procedimentos"
                   :class="{'container-dente-selecionado': denteSelecionado }">
                <div class="remover-dente-selecionado" v-if="denteSelecionado">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn class="close__button" icon v-on="on" @click="removerDenteSelecionado">
                        <v-icon color="white">close</v-icon>
                      </v-btn>
                    </template>
                    Remover dente selecionado
                  </v-tooltip>
                </div>
                <OdontogramaMenuLateralDireito
                    :dente="denteSelecionado"
                    :atendimentoId="atendimentoSelecionadoId"
                    :permiteEditarAtendimento="permiteEditarAtendimento"
                    @procedimentoInseridoAtualizado="atualizarInformacoesDente"
                />
              </div>
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'
import OdontogramaArcadaSuperior from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaArcadaSuperior.vue'
import OdontogramaArcadaInferior from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaArcadaInferior.vue'
import OdontogramaAtendimento from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaAtendimento.vue'
import OdontogramaMenuLateralDireito
from '@/views/pages/cadastros/paciente/comum/odontograma/OdontogramaMenuLateralDireito.vue'
import ServicosModal from '@/views/modais/servicos/ServicosModal.vue'

export default {
    components: {
        ServicosModal,
        OdontogramaMenuLateralDireito,
        OdontogramaAtendimento, OdontogramaArcadaSuperior, OdontogramaArcadaInferior
    },
    nome: 'Odontograma',
    props: {
        paciente: Object
    },
    data() {
        return {
            idPaciente: null,
            atendimentoSelecionadoId: null,
            permiteEditarAtendimento: false,
            dentesQuadrante1: [],
            dentesQuadrante2: [],
            dentesQuadrante3: [],
            dentesQuadrante4: [],
            visualizarQuadrantes: false,
            denteSelecionado: null,
            modalServicos: false
        }
    },
    async mounted() {
        this.setarIdPaciente()
        await this.buscarDentes()
    },
    methods: {
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = this.$route.params.id
            }
        },
        async buscarDentes() {
            const input = {pacienteId: {value: this.idPaciente}}
            this.setMensagemLoading('Buscando odontograma...')
            const resposta = await this.$store.dispatch(actionTypes.ODONTOGRAMA.BUSCAR_ODONTOGRAMA, input)
            if (resposta) {
                this.dentesQuadrante1 = resposta.dentesQuadrante1
                this.dentesQuadrante2 = resposta.dentesQuadrante2
                this.dentesQuadrante3 = resposta.dentesQuadrante3
                this.dentesQuadrante4 = resposta.dentesQuadrante4
            }
        },
        filtrarAtendimentos() {
            if (!this.atendimentoSelecionadoId) return
            this.dentesQuadrante1 = this.filtrarQuadrante(this.dentesQuadrante1)
            this.dentesQuadrante2 = this.filtrarQuadrante(this.dentesQuadrante2)
            this.dentesQuadrante3 = this.filtrarQuadrante(this.dentesQuadrante3)
            this.dentesQuadrante4 = this.filtrarQuadrante(this.dentesQuadrante4)
        },
        filtrarQuadrante(quadrante) {
            return quadrante.map(dente => {
                const atendimentosFiltrados = (dente.atendimentosList || []).filter(a => a.atendimentoId === this.atendimentoSelecionadoId)

                const possuiProcedimentos = atendimentosFiltrados.length > 0
                const possuiCanal = atendimentosFiltrados.some(obj => obj.ehCanal)
                const foiExtraido = atendimentosFiltrados.some(obj => obj.ehExtraido)
                const possuiRestauracao = atendimentosFiltrados.some(obj => obj.ehRestaurado)

                return {
                    ...dente,
                    possuiProcedimentos: possuiProcedimentos,
                    possuiCanal: possuiCanal,
                    foiExtraido: foiExtraido,
                    possuiRestauracao: possuiRestauracao,
                    atendimentosList: atendimentosFiltrados
                }
            })
        },
        async selecionarAtendimento(atendimento) {
            this.atendimentoSelecionadoId = atendimento.id
            this.permiteEditarAtendimento = atendimento.permiteEditar
            if (this.$store.state.odontograma.atualizarOdontograma) {
                await this.buscarDentes()
            }
            this.filtrarAtendimentos()
        },
        async removerAtendimentoSelecionado() {
            this.atendimentoSelecionadoId = null
            this.permiteEditarAtendimento = false
            if (this.$store.state.odontograma.atualizarOdontograma) {
                await this.buscarDentes()
                this.atualizarDenteSelecionado()
            }
        },
        async atualizarInformacoesDente() {
            await this.buscarDentes()
            this.atualizarDenteSelecionado()
            this.filtrarAtendimentos()
        },
        atualizarDenteSelecionado() {
            if (this.denteSelecionado) {
                const arrayDentesUnico = [...this.dentesQuadrante1, ...this.dentesQuadrante2, ...this.dentesQuadrante3, ...this.dentesQuadrante4]
                this.denteSelecionado = arrayDentesUnico.find(dente => dente.id === this.denteSelecionado.id)
            }
        },
        modoVisualizarQuadrante() {
            this.visualizarQuadrantes = !this.visualizarQuadrantes
        },
        selecionarDente(denteSelecionado) {
            this.denteSelecionado = denteSelecionado
        },
        removerDenteSelecionado() {
            this.denteSelecionado = null
        },
        async buscarHistoricoProcedimentos() {
            this.denteSelecionado = null
            this.atendimentoSelecionadoId = null
            this.permiteEditarAtendimento = false
            await this.buscarDentes()
            this.filtrarAtendimentos()
        },
        abrirModalServicos() {
            this.modalServicos = true
        },
        fecharModalServicos() {
            this.modalServicos = false
        },
    }
}
</script>

<style scoped lang="stylus">

.container-odontograma
  display flex
  justify-content center
  align-items center
  overflow-x auto
  border solid 1px #e0e0e0
  border-radius 10px
  background-color rgba(239, 249, 240, 0.5)
  margin 0 5px
  width 50%

.container-lado-quadrante
  display flex
  flex-direction column
  justify-content center
  width 50px

  label
    transform rotate(270deg)
    display inline-block
    white-space nowrap

.container-um-odontograma
  display flex
  flex-direction row
  height 500px
  padding 10px

.container-lateral-atendimentos
  width 25%
  z-index 1

.container-lateral-procedimentos
  width 25%
  background-color #ffffff
  border solid 1px #e0e0e0
  border-radius 10px
  padding 10px
  padding-bottom 0

.container-dente-selecionado
  border-top-left-radius 0px

.remover-dente-selecionado
  background-color var(--theme-primary)
  position relative
  left -46px
  top -11px
  width 36px
  heigh 48px
  border-radius 8px 0 0 8px
  box-shadow -2px 2px 8px rgba(0, 0, 0, .3)
  display flex
  align-items center
  justify-content center

.remover-dente-selecionado:hover
  box-shadow -4px 4px 14px rgba(0, 0, 0, .4)


</style>